export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20organic%20gradient%20shapes%20in%20warm%20amber%20terracotta%20and%20sage%20green%20tones%20with%20subtle%20product%20silhouette%20overlays%2C%20modern%20editorial%20design%2C%20soft%20ethereal%20wisps%20of%20color%20blending%20into%20cream%20white%20space%2C%20artistic%20commercial%20photography%2C%20elegant%20minimal%20composition%20with%20gentle%20movement%2C%20no%20text%2C%20no%20logos%2C%20serene%20sophisticated%20atmosphere&width=1920&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="Hipobuy Spreadsheet product discovery platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-10 lg:px-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 text-white/90 text-xs md:text-sm font-medium tracking-wide mb-6 border border-white/20">
            Updated July 2026
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-5">
            Hipobuy Spreadsheet 2026 – The Ultimate Product Discovery Database
          </h1>
          <p className="text-base md:text-lg text-white/75 leading-relaxed mb-8 max-w-xl">
            Find the latest <strong>hipobuy spreadsheet</strong> collections, verified product lists, comparison guides, and shopping resources in one powerful platform. Discover, compare, and organize products smarter.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#about"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Explore Spreadsheet Database
              <i className="ri-arrow-down-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/15 text-white border border-white/30 font-medium text-sm md:text-base whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
            >
              View All Categories
              <i className="ri-grid-line text-base w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}